<template>
    <div>
        <SearchObject
            :disabled="disabled"
            :value="value"
            @input="$emit('input', $event)"
            @select="$emit('select', $event)"
            :base-url="baseUrl"
            :label="label || $translate('select_shipment')"
            :additional-params="{ ordering: '-shipment_id', ...additionalParams }"
            :item-text="itemText"
            :readonly="readonly"
            :required="required"
            :autofocus="autofocus"
            :hide-details="hideDetails"
            :dense="dense"
            :outlined="outlined"
            :error-messages="errorMessages"
            ref="search"
        >
            <template slot="item" slot-scope="{ item }">
                <div class="d-block py-2">
                    <div class="font-weight-bold">
                        {{ item.shipment_id }} - {{ item.delivery_date }}
                        <template v-if="item.recipient_data">
                            - {{ item.recipient_data.name }}</template
                        >
                    </div>

                    <div>
                        <template v-if="item.initiator_data?.name">
                            {{ item.initiator_data.name }} -
                        </template>
                        {{ item.products_count }}
                        {{
                            item.products_count > 1
                                ? $translate("products_count")
                                : $translate("product_count")
                        }}
                        -
                        {{ item.items_count }}
                        {{
                            item.items_count > 1
                                ? $translate("items_count")
                                : $translate("item_count")
                        }}
                    </div>
                </div>
            </template>
        </SearchObject>
    </div>
</template>

<script>
export default {
    name: "SearchProvider",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/shipments/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        outlined: { type: Boolean, default: false },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        itemText(item) {
            let label = `${item.shipment_id} - ${item.delivery_date}`;
            if (item.recipient_data) {
                label += ` - ${item.recipient_data.name}`;
            }

            label += ` - ${item.products_count} ${
                item.products_count > 1
                    ? this.$translate("products_count")
                    : this.$translate("product_count")
            }`;
            label += ` - ${item.items_count} ${
                item.items_count > 1
                    ? this.$translate("items_count")
                    : this.$translate("item_count")
            }`;

            return label;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_shipment: "Select a shipment",
                product_count: "product",
                products_count: "products",
                item_count: "item",
                items_count: "items",
            },
            fr: {
                select_shipment: "Sélectionnez une expédition",
                product_count: "produit",
                products_count: "produits",
                item_count: "elément",
                items_count: "eléments",
            },
        },
    },
};
</script>
